import PDF from './PDF'
import Fallback from './Fallback'

import { downloadURL } from '../../../../utilities'

const getBlobData = (file: Blob, mime: Media['mime']) => {
  const newObj = new Blob([file], { type: mime })

  return new Promise<string>(res => {
    const fileReader = new FileReader()
    fileReader.onload = e => {
      res(e.target.result as string)
    }
    fileReader.readAsDataURL(newObj)
  })
}

type GetElementType = {
  media: Media
  file: Blob
  classes: Record<string, string>
  finishLoad: () => void
  url: string
}

export const getElement = async ({
  media,
  file,
  classes,
  finishLoad,
  url
}: GetElementType) => {
  if (media.type === 'image') {
    finishLoad()

    return (
      <img
        src={url}
        alt={media.filename}
        onClick={() => downloadURL(media.filename, url)}
        className={classes.img}
      />
    )
  }

  if (media.mime === 'application/pdf') {
    const data = await getBlobData(file, media.mime)

    return (
      <div className={classes.pdf}>
        <PDF data={data} onLoad={finishLoad}>
          <Fallback name={media.filename} media={file} onRender={finishLoad} />
        </PDF>
      </div>
    )
  }

  if (media.type === 'audio') {
    finishLoad()

    return <audio controls src={url} className={classes.audio} />
  }

  if (media.type === 'video') {
    finishLoad()

    return <video controls src={url} className={classes.video} />
  }

  return null
}
